/* eslint-disable @next/next/no-img-element */
import React, { useState } from 'react';
import ContainerHome24 from '../../atoms/ContainerHome24';
import WhiteButton from '../../atoms/WhiteButton/WhiteButton';
import Styles from './BancoDoAuto25BannerAbr26.css';
import RedButton from '@/components/atoms/RedButton';

function BancoDoAuto25BannerAbr26() {
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);

  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }
  return (
    <>
      <section id="banco-auto-25-banner">
        <div className="bg-hero">
          {typeof window === 'undefined' ? (
            <></>
          ) : (
            <>
              {width <= 312 && (
                <picture>
                  <source
                    type="image/png"
                    srcSet="assets/banco-do-auto25/hero-abr26/banner-312.png"
                  />
                  <img
                    src="assets/banco-do-auto25/hero-abr26/banner-312.png"
                    alt="Pessoa saindo de novo carro financiado com a Santander Financiamentos com paisagem arborizada ao fundo."
                    className=""
                  />
                </picture>
              )}
              {width > 312 && width <= 600 && (
                <picture>
                  <source
                    type="image/png"
                    srcSet="assets/banco-do-auto25/hero-abr26/banner-450.png"
                  />
                  <img
                    src="assets/banco-do-auto25/hero-abr26/banner-450.png"
                    alt="Pessoa saindo de novo carro financiado com a Santander Financiamentos com paisagem arborizada ao fundo."
                    className=""
                  />
                </picture>
              )}
            </>
          )}
        </div>
        {/* <div className="fade-hero-santander" /> */}
        <ContainerHome24>
          <div className="bg-hero">
            {typeof window === 'undefined' ? (
              <></>
            ) : (
              <>
                {width > 600 && width <= 1280 && (
                  <picture>
                    <source
                      type="image/png"
                      srcSet="assets/banco-do-auto25/hero-abr26/banner-1280.png"
                    />
                    <img
                      src="assets/banco-do-auto25/hero-abr26/banner-1280.png"
                      alt="Pessoa saindo de novo carro financiado com a Santander Financiamentos com paisagem arborizada ao fundo."
                      className=""
                    />
                  </picture>
                )}
                {width > 1280 && (
                  <picture>
                    <source
                      type="image/png"
                      srcSet="assets/banco-do-auto25/hero-abr26/banner-1360.png"
                    />
                    <img
                      src="assets/banco-do-auto25/hero-abr26/banner-1360.png"
                      alt="Pessoa saindo de novo carro financiado com a Santander Financiamentos com paisagem arborizada ao fundo."
                      className=""
                    />
                  </picture>
                )}
              </>
            )}
          </div>
          <div className="hero-contain">
            <div className="hero-buttons">
              <WhiteButton
                href="https://www.cliente.santanderfinanciamentos.com.br/originacaocliente/?int_source=portalSF&int_medium=banco-do-auto:banner&int_campaign=simular-financiamento"
                target="_blank"
                rel="noopener"
                className="btn-simulate"
              >
                Quero Simular
              </WhiteButton>
              {/* <RedButton href="#santander-carousel" id="hero-button-outros-produtos">
                Produtos
              </RedButton> */}
            </div>
          </div>
        </ContainerHome24>
        <style jsx>{Styles}</style>
      </section>
    </>
  );
}

export default BancoDoAuto25BannerAbr26;
